import React from 'react';
import { Table } from 'react-bootstrap';
import DocumentPreview from '../DocumentPreview/DocumentPreview';
import { ButtonTooltip } from '../../components';
import Icon from '../../components/Icons';

const AttendanceRecordReportFilterDataTable = ({
  attendances,
  setDocumentModalBody,
  setDocumentModalShow,
  attendancesTotal
}) => {
  const styleButtonTooltip = {
    width: 'auto',
    height: 'auto',
    borderRadius: '10%',
    display: 'initial'
  };

  const renderResult = attendance => {
    return (
      <tr>
        <td className="text-center align-middle">{attendance.date_formatted}</td>
        <td className="text-center align-middle">{attendance.shift}</td>
        <td className="text-center align-middle">{attendance.attendance_day}</td>
        <td className="text-center align-middle">{attendance.shift_break}</td>
        <td className="text-center align-middle">{attendance.attendance_break}</td>
        <td className="text-center align-middle">
          <>
            {attendance?.document && (
              <ButtonTooltip
                onClick={() => {
                  setDocumentModalBody(
                    <DocumentPreview
                      documentId={attendance?.document?.id}
                      employeeId={attendance?.document?.employee_id}
                    />
                  );
                  setDocumentModalShow(true);
                }}
                variant="circle-info"
                className="btn-circle"
                style={styleButtonTooltip}
                toolbarVariant="justify-content-center"
                size="sm"
                text="Ver Pacto H.E"
                disabledTooltip
              >
                <Icon icon="profile" /> Ver Pacto H.E
              </ButtonTooltip>
            )}
            {attendance.observation}
          </>
        </td>
      </tr>
    );
  };

  const renderData = () => {
    return (
      <>
        <Table className="custom-data-table" bordered size="sm" style={{ fontWeight: 400 }}>
          <thead className="rdt_TableHeadRow" style={{ backgroundColor: '#EBEBEB', textTransform: 'uppercase' }}>
            <tr className="rdt_TableCol">
              <th className="text-center align-middle">Fecha</th>
              <th className="text-center align-middle">Jornada Ordinaria</th>
              <th className="text-center align-middle">Marcas Reales</th>
              <th className="text-center align-middle">Colación</th>
              <th className="text-center align-middle">Marcas Colación</th>
              <th className="text-center align-middle">Comentarios</th>
            </tr>
          </thead>
          <tbody>{attendances && attendances.map(attendance => renderResult(attendance))}</tbody>
          <tfoot style={{ backgroundColor: '#EBEBEB' }}>
            <tr>
              <td className="text-center align-middle"> Total </td>
              <td className="text-center align-middle"> {attendancesTotal.parsed_shift_time} </td>
              <td className="text-center align-middle"> {attendancesTotal.parsed_attendance_day_t} </td>
              <td className="text-center align-middle"> {attendancesTotal.parsed_shift_break_time} </td>
              <td className="text-center align-middle"> {attendancesTotal.p_attendance_break_t} </td>
              <td className="text-center align-middle"> </td>
            </tr>
          </tfoot>
        </Table>
      </>
    );
  };

  return <>{renderData()}</>;
};

export default AttendanceRecordReportFilterDataTable;
